<template>
  <section>
    <div class="box">
      <div class="box-title">
        <h3>SMS API API.BRASIL</h3>
      </div>
      <div class="box-content">
        <p>
          Configure os dados de acesso da api de whats da API BRASIL.
        </p>
        <a href="https://doc.apibrasil.io/" target="_blank">https://doc.apibrasil.io/</a>
        <form>
          <div class="flex margin-top-l">
            <div class=" flex-1">
              <label>API URL</label>
              <input class="input" type="text" v-model="newSms.apiUrl" />
            </div>
            <div class="item flex-1">
              <label>BEARER TOKEN</label>
              <input class="input" type="text" v-model="newSms.bearerToken" />
            </div>
            <div v-if="false" class="item flex-1">
              <label>API TOKEN</label>
              <input class="input" type="text" v-model="newSms.apiToken" />
            </div>
          </div>
          <div class="flex margin-top-l">
            <div class=" flex-1">
              <label>DEVICE TOKEN</label>
              <input class="input" type="text" v-model="newSms.deviceToken" />
            </div>
          </div>
          <div class="flex margin-top-l">
            <div class="">
              <div class="button primary" @click="saveSMTP()">
                Salvar
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";

import {
  saveIntegration,
  getIntegrations,
} from "@/services/integration";


export default {
  name: "whatsapp",
  data() {
    return {
      newSms: {
        apiUrl: '',
        apiToken: '',
        deviceToken: '',
        bearerToken: '',
      }
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
  },
  mounted() {
    this.getIntegrations();
  },
  methods: {
    saveSMTP() {
      let data = {
        apiUrl: this.newSms.apiUrl,
        apiToken: this.newSms.apiToken,
        deviceToken: this.newSms.deviceToken,
        bearerToken: this.newSms.bearerToken,
      };

      if (!data.apiUrl || !data.bearerToken) {
        this.$toast.error({
          title: "Erro",
          message: "Você precisa preencher os campos para salvar a integração!",
        });
      }

      let params = {
        sms: data
      };

      saveIntegration(params)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Integração salva com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao tentar salvar integração",
          });
        });
    },
    getIntegrations() {
      getIntegrations()
        .then((result) => {
          this.newSms = result.sms;
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falhou ao buscar integrações",
          });
        });
    },

  },
};
</script>
